<template>
  <div :class="[headerClassName, 'header-wrap']">
    <!-- <div class="banner" v-if="isShowBanner" @click="goActivity"></div> -->
    <!-- <div class="advert" @click="goActivity">
      <img class="showImg" :src="advertitem" alt />
    </div> -->

    <header id="header">
      <!-- logo -->
      <div class="left">
        <div class="logo" @click="backFrontIndex">
          <!-- <router-link tag="h1" :to="{ name: 'frontIndex'}" class="img"> -->
          <!-- <img v-if="type == '1'" src="@/assets/images/logo2.png" alt />
          <img v-else src="@/assets/images/logo.png" alt /> -->
          <!-- </router-link> -->
        </div>
        <!-- end-logo -->
        <v-nav></v-nav>
      </div>
      <div class="right">
        <search
          :showHeaderSearch="showHeaderSearch"
          @selectSearch="selectSearch"
          @clickSearch="clickSearch"
        ></search>
        <info></info>
      </div>
    </header>
  </div>
</template>

<script>
import vNav from "./module/nav.vue";
import search from "./module/search.vue";
import info from "./module/info.vue";

export default {
  components: {
    vNav,
    search,
    info,
  },
  props: {
    showHeaderSearch: {
      type: Boolean,
      default: false,
    },
    headerClassName: {
      type: String,
      default: "header-opacity",
    },
    isShowBanner: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      type: "1",
      advertitem: require("@/assets/images/pp_advert.gif"),
    };
  },
  mounted() {
    if (this.$route.path == "/") {
      this.type = "1";
    } else {
      this.type = "2";
    }
  },
  watch: {
    $route(to, from) {
      if (this.$route.path == "/") {
        this.type = "1";
      } else {
        this.type = "2";
      }
    },
  },
  methods: {
    goActivity() {
      let routeUrl = this.$router.resolve({ path: "/11huodong" });
      window.open(routeUrl.href, "_blank");
    },
    backFrontIndex() {
      this.$store.commit("headerMenuId", null);
      this.$router.push({ path: "/materialDownload" });
    },
    goLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    //选中搜索选项
    selectSearch(val) {
      console.log(val);
    },
    //点击搜索全站
    clickSearch(val) {
      console.log(val);
    },
  },
};
</script>
<style lang="scss">
$white-opacity: hsla(0, 0%, 100%, 0.8);
.header-wrap {
  .advert {
    width: 100%;
    height: 50px;
    .showImg {
      width: 100%;
      height: 90%;
      cursor: pointer;
    }
  }

  &.index {
    nav {
      margin: 0;
    }
    .list .item:hover a,
    .list .item:hover .show-more .iconfont,
    .header-user .message .btn-message:hover,
    .user .user-text .dot,
    .header-info .avatar-text a:hover {
      color: #fff;
    }
    .list .item a,
    .list .item .show-more .iconfont,
    .header-user .message .btn-message,
    .user .user-text .name span,
    .header-info .avatar-text a {
      color: $white-opacity;
    }
    .list .item:hover .pop-list li a {
      color: #333;
      &:hover {
        color: #EA4335;
      }
    }
  }
  &.index-fixed {
    nav {
      margin: 0;
    }
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.header-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 10000;
  box-shadow: 0 4px 10px 0 rgba(48, 62, 83, 0.06);
  &.header-opacity {
    background: hsla(0, 0%, 100%, 0.96) !important;
  }
  &.index-fixed {
    position: fixed;
    top: 0;
    left: 0;
    box-shadow: 0 30px 60px -10px rgba(48, 62, 83, 0.24);
    #header {
      background: hsla(0, 0%, 100%, 0.96);
    }
  }
  &.index {
    position: absolute;
    top: 0;
    left: 0;
    box-shadow: unset;
    background: transparent;
    #header {
      background: transparent;
    }
    .pop-list {
      li {
        a {
          color: #333 !important;
        }
        &:hover {
          a {
            color: #EA4335 !important;
          }
        }
      }
      li a {
        color: #333;
      }
    }
    #header {
      background: transparent;
      .logo {
        flex-shrink: 0;
      }
    }
  }
  #header nav .index-fixed {
    nav {
      margin: 0 auto;
    }
  }
  #header {
    margin: 0 auto;
    padding: 0 8px 0 8px;
    position: relative;
    display: flex;
    height: 70px;
    width: 100%;
    min-width: 1200px;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    transition: background-color 0.6s ease;
    .left {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      margin-right: 20px;
    }
    .right {
      display: flex;
      align-items: center;
    }

    .logo {
      position: relative;
      cursor: pointer;

      display: inline-block;
      width: 180px;
      height: 44px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.banner {
  width: 100%;
  height: 44px;
  background-image: url(~@/assets/images/header/banner.gif);
  background-repeat: no-repeat;
  background-color: rgb(234, 45, 62);
  background-size: 1920px;
  min-width: 1920px;
  background-position: center;
  cursor: pointer;
}
</style>
